import React from 'react';
import OpportunityBoardSettings from '../../components/crm/settings/OpportunityBoardSettings';

export const CrmSettingsPage: React.FC = () => {
  return <OpportunityBoardSettings />;
};
